import { spendLimitTone, type SpendLimitTone } from "@/lib/spend-limit"
import { cn } from "@/lib/utils"

const CIRCUMFERENCE = 37.7
const STROKE = 2.5

const TONE_STROKE: Record<SpendLimitTone, string> = {
  accent: "var(--ui-accent)",
  amber: "var(--ui-status-rendering)",
  danger: "var(--ui-danger)",
}

export type SpendLimitRingSize = 12 | 20 | 28 | 36

/** Кольцо личного лимита (docs/billing_limits.md §9). */
export function SpendLimitRing({
  percent,
  size = 20,
  className,
  trackClassName,
}: {
  percent: number
  size?: SpendLimitRingSize
  className?: string
  trackClassName?: string
}) {
  const clamped = Math.min(Math.max(percent, 0), 1)
  const full = clamped >= 1
  const arc = full ? CIRCUMFERENCE : Math.max(0.01, clamped * CIRCUMFERENCE - STROKE)
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden
      className={cn("block shrink-0 overflow-visible", className)}
    >
      <circle cx="8" cy="8" r="6" strokeWidth={STROKE} className={cn("stroke-ui-range-track", trackClassName)} />
      <circle
        cx="8"
        cy="8"
        r="6"
        strokeWidth={STROKE}
        strokeLinecap={full ? undefined : "round"}
        strokeDasharray={full ? undefined : `${arc.toFixed(2)} ${CIRCUMFERENCE}`}
        transform="rotate(-90 8 8)"
        style={{ stroke: TONE_STROKE[spendLimitTone(clamped)] }}
      />
    </svg>
  )
}
